import React, { useEffect } from "react";
import { useCookies } from "react-cookie";
import { useLocation, useNavigate } from "react-router-dom";
import userContext from "../context/UserContext";
import ErrorModal from "../ErrorModal/ErrorModal";
import Header from "../Header/Header";

// import UserState from "../context/UserState";

const Layout = (props) => {
  let location = useLocation();
  let navigate = useNavigate();

  console.log(location);
  const [cookies, setCookie] = useCookies(["toonflix"]);
  const { state } = React.useContext(userContext);
  const queryParams = new URLSearchParams(window.location.search);
  console.log("location ANI ", queryParams.get("ani"));

  let ani = queryParams.get("ani");
  let userStatus = queryParams.get("status");
  let lang = queryParams.get("lang");
  console.log("ANI  ", ani);
  console.log("status ", userStatus);
  console.log("lang ", lang);
  const { status } = state;

  console.log(cookies);

  useEffect(() => {
    console.log("a> ", ani);
    if (
      (ani !== "null" || userStatus !== "null") &&
      (ani !== null || userStatus !== null)
    )
      setCookie(
        "toonflix",
        {
          ani: queryParams.get("ani"),
          status: queryParams.get("status"),
          lang: queryParams.get("lang"),
        },
        { path: "/" }
      );
  }, []);

  useEffect(() => {
    console.log(" INSIDE USE EFFECT", Object.keys(cookies).length);
    if (userStatus === null || userStatus === 0) {
      // header less user or non subs
      // console.log("INSIDE HOMMMMM", cookies.toonflix.status);

      if (Object.keys(cookies).length > 0) {
        // if cookis exist
        console.log("INSIDE HOMMMMM", cookies.toonflix.status);
        if (cookies.toonflix.status === "0") {
          console.log("INSIDE HOMMMMM===>>>", cookies.toonflix.status);
          return navigate("/landing/toonflix/home");
        } else {
          console.log("INSIDE HOMMMMM 111===>>>", cookies.toonflix.status);
          return navigate("/landing/toonflix/redirect");
        }
      } else navigate("/home"); // if no cookie send to home
    }
    if (userStatus === "1") {
      //user status =1
      console.log("HHHH HERE NOWWWW  ===>", typeof userStatus);
      return navigate("/landing/toonflix/redirect");
    } else navigate("/landing/toonflix/home");
  }, []);

  return (
    <div>
      {!location.pathname.includes("home") ? <Header /> : null}
      {/* {cookies.toonflix === "null" && location.pathname !== "/toonflix/home" ? (
        <ErrorModal message="Invalid User" />
      ) : null} */}
      {Object.keys(cookies).length > 0 && (
        <div className="content">{props.children}</div>
      )}
    </div>
  );
};

export default Layout;
